// components/TopBar.js
import React, { useState } from 'react';
import {
  AiOutlineSync, AiOutlineGlobal
} from 'react-icons/ai';
import { t } from 'ttag';
import './css/TopBar.css'; // Импортируем файл стилей
import './css/LanguageSwitcher.css'; // Додамо стиль для перемикача мов (створимо його пізніше)
import uk from '../i18n/uk.png';
import en from '../i18n/en.png';
import ru from '../i18n/ru.png';
import { mixpanel } from './mp.js';

function TopBar({ email, handlesetIndex, index, setIsAuthorized, setlocale }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleMenuAct = (ind) => {
    handlesetIndex(ind);
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleMenuActUpd = () => {
    handlesetIndex(0);
    setIsAuthorized(false);
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleLanguageMenu = () => {
    setIsLanguageMenuOpen(!isLanguageMenuOpen);
  };

  const changeLanguage = (lang) => {
    mixpanel.track('topMenu-changeLanguage-to-' + lang)
    localStorage.setItem("lng", lang)
    setlocale(lang);
    setIsLanguageMenuOpen(false);
  };
  return (
    <div className="top-bar">
      <div>
        <div className="top-bar-title">SoNat</div>
        <div className="top-bar-subtitle">{email}</div>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <button style={{ display: "flex" }} className="menu-button" onClick={() => { toggleMenuActUpd(); }} >
          <AiOutlineSync />
        </button>

        <div className="language-switcher">
          <button className="language-button" onClick={toggleLanguageMenu}>
            <AiOutlineGlobal />
          </button>
          {isLanguageMenuOpen && (

            <div className="language-dropdown">
              <div>
                <button className="language-option" onClick={() => changeLanguage('en')}><img src={en} /> English</button>
                <button className="language-option" onClick={() => changeLanguage('uk')}><img src={uk} /> Українська</button>
                <button className="language-option" onClick={() => changeLanguage('ru')}><img src={ru} /> Русский</button>
              </div>
            </div>
          )}
        </div>
        <button className="menu-button" onClick={toggleMenu}>
          ☰
        </button>
        {isMenuOpen && (
          <div className="dropdown-menu">
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuAct(0); }} >{t`Home`}</a>
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuAct(1); }} >{t`Trade`}</a>
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuAct(2); }} >{t`License`}</a>
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuAct(3); }} >{t`Finance`}</a>
            <a href="#" className="dropdown-item" onClick={() => { toggleMenuAct(4); }} >{t`Affiliate`}</a>
            <a href="https://t.me/bitbook_support" className="dropdown-item"  >{t`Support`}</a>
          </div>
        )}

      </div>
    </div>
  );
}

export { TopBar };